import React from 'react';
import {
  CasePlanAddSection,
  CasePlanSection,
  CasePlanSectionSkeleton,
} from '@orijinworks/frontend-commons';
import {
  CASE_PLAN_EDITABLE_SECTION_INDEX,
  CASE_PLAN_SECTION_SKELETON_COUNT,
} from '../../../../constants/reentry-planning.constants';
import { EditableCasePlanSection } from '../EditableCasePlanSection';

export function CasePlanDetailsSections({
  isSectionsLoading,
  isReadOnly = false,
  sections,
  collapsedSections,
  onToggleCollapse,
  onAddWidget,
  onAddSection,
}) {
  if (isSectionsLoading) {
    return <CasePlanSectionSkeleton count={CASE_PLAN_SECTION_SKELETON_COUNT} />;
  }

  const sharedSectionProps = (section) => ({
    title: section.title,
    widgets: section.widgets,
    visibleToLearner: false,
    visibleToLearnerDisabled: true,
    onVisibleToLearnerChange: () => {},
    collapsed: collapsedSections[section.id] ?? false,
    onToggleCollapse: () => onToggleCollapse(section.id),
    onEmptyStateButtonClick: () => onAddWidget(section.id),
    onAddWidget: () => onAddWidget(section.id),
  });

  const renderAddSection = (position, sectionId) => (
    <CasePlanAddSection
      key={`add-section-${position}-${sectionId}`}
      onClick={onAddSection}
    />
  );

  if (sections.length === 0) {
    return [renderAddSection('start', 'empty')];
  }

  const sectionElements = sections.flatMap((section, sectionIndex) => {
    const isEditableSection =
      !isReadOnly && sectionIndex === CASE_PLAN_EDITABLE_SECTION_INDEX;
    const sectionProps = sharedSectionProps(section);

    const sectionElement = isEditableSection ? (
      <EditableCasePlanSection
        key={section.id}
        initialDescription={section.description ?? ''}
        {...sectionProps}
      />
    ) : (
      <CasePlanSection
        key={section.id}
        description={section.description ?? ''}
        {...sectionProps}
      />
    );

    return [renderAddSection('before', section.id), sectionElement];
  });

  const lastSection = sections[sections.length - 1];
  sectionElements.push(renderAddSection('after', lastSection.id));

  return sectionElements;
}
